import React from 'react';
import FormField from '../../FormField';
import MultiSelectDropDown from 'reusableComponents/multipleDropdown';
import { FormFieldProps } from '../../FormTypes';
import { ProviderSelection } from '../../../JobRequestTypes';
import { useAlwaysValid } from '../../FormHook';
import { useJobFormContext } from '../../../JobFormContext';
import { Text } from 'library';

interface PreferredProvidersInputProps {
    preferredProviders: FormFieldProps<ProviderSelection[]>;
}

export default function PreferredProvidersInput({ preferredProviders }: PreferredProvidersInputProps) {
    const { preferredProviders: values } = useJobFormContext();

    useAlwaysValid(preferredProviders);

    function onChange(event: { target: { value: number[] } }) {
        const newProviderIds = event.target.value;
        const newProviders = values.filter((choice) => newProviderIds.includes(choice.id));

        preferredProviders.setValue(newProviders);
    }

    return values.length > 0 ? (
        <>
            <div style={{ marginTop: 15 }} />

            <Text variant="h2" bold>
                Saved Providers
            </Text>
            <FormField>
                <MultiSelectDropDown
                    helperText="Selected providers will receive personal invitations to apply"
                    selected={toIds(preferredProviders.value)}
                    fields={values}
                    onChange={onChange}
                />
            </FormField>
        </>
    ) : null;
}

function toIds(providers: ProviderSelection[]) {
    return providers.map((provider) => provider.id);
}
